import { useState } from "react";
import "./All_Universities.css";

import InquiryFormModal from "../../common_components/InquiryFormModal/InquiryFormModal";
import Main_heading_holder from "../../common_components/main_heading_holder/Main_heading_holder";

const All_Universities = () => {
  // const staticUniversities = [
  //   {
  //     id: 39,
  //     name: "Dr. D.Y. Patil Vidyapeeth",
  //     url: "dr-d-y-patil-university",
  //     image: "/assets/images/home/primium-university/dpu.png",
  //     alt_tag: "Dr. D.Y. Patil Vidyapeeth",
  //     type: "Centre for Online Learning",
  //     nirf: "#44",
  //     specialisations: "14",
  //     naac: "A++",
  //     accred: "UGC · AICTE · NAAC A++",
  //     descHtml: `         <p class="uni-desc">
  //         DY Patil University holds <strong>NAAC A++ accreditation</strong>
  //         and an NIRF rank of #44, offering 14 specialisations through its
  //         UGC-approved online MBA program. AICTE-approved and fully recognised
  //         for government employment and higher education across India.         </p>
  //     `,
  //     mode: "Online",
  //   },

  //   {
  //     id: 44,
  //     name: "NMIMS University",
  //     url: "nmims-university",
  //     image: "/assets/images/home/primium-university/NMIMS .webp",
  //     alt_tag: "NMIMS University",
  //     type: "Centre for Distance & Online Education",
  //     nirf: "#24",
  //     specialisations: "5",
  //     naac: "A++",
  //     accred: "UGC · AICTE · NAAC A++",
  //     descHtml: `
  //   <p class="uni-desc">
  //     <strong>Ranked #24</strong> by NIRF with NAAC A++ accreditation,
  //     NMIMS is one of India's most reputed management universities.
  //     Its UGC-approved distance MBA covers five specialisations including
  //     Finance, Marketing, and HR.
  //   </p>
  // `,
  //     mode: "Online",
  //   },

  //   {
  //     id: 34,
  //     name: "Amity University Online",
  //     url: "amity-university",
  //     image: "/assets/images/home/primium-university/amity.png",
  //     alt_tag: "Amity University Online",
  //     type: "Premier Private University",
  //     nirf: "#37",
  //     specialisations: "18",
  //     naac: "A+",
  //     accred: "UGC · AICTE · NAAC A+",
  //     descHtml: `
  //   <p class="uni-desc">
  //     Amity University Online is ranked #37 by NIRF with
  //     <strong>NAAC A+ accreditation</strong>, offering 18 specialisations
  //     across MBA, BBA, BCA, MCA, and B.Com.
  //   </p>
  // `,
  //     mode: "Online",
  //   },

  //   {
  //     id: 45,
  //     name: "Sikkim Manipal University",
  //     url: "sikkim-manipal-university",
  //     image: "/assets/images/home/primium-university/Sikkim Manipal .webp",
  //     alt_tag: "Sikkim Manipal University",
  //     type: "Distance Education Pioneer",
  //     nirf: "#151",
  //     specialisations: "6",
  //     naac: "A+",
  //     accred: "UGC · AICTE · NAAC A+",
  //     descHtml: `
  //   <p class="uni-desc">
  //     One of India's oldest distance education universities, SMU has
  //     served over <strong>2 lakh</strong> learners since 2001.
  //     Ranked #151 by NIRF with NAAC A+ accreditation.
  //   </p>
  // `,
  //     mode: "Online",
  //   },

  //   {
  //     id: 46,
  //     name: "Online Manipal",
  //     url: "online-manipal",
  //     image: "/assets/images/home/primium-university/Manipal .webp",
  //     alt_tag: "Online Manipal",
  //     type: "Ranked #3 in India",
  //     nirf: "#3",
  //     specialisations: "13",
  //     naac: "A++",
  //     accred: "UGC · AICTE · NAAC A++",
  //     descHtml: `
  //   <p class="uni-desc">
  //     Online Manipal is <strong>ranked #3</strong> in India by NIRF
  //     and holds NAAC A++ accreditation. Its UGC-entitled online MBA
  //     spans 13 specialisations.
  //   </p>
  // `,
  //     mode: "Online",
  //   },

  //   {
  //     id: 37,
  //     name: "Chandigarh University Online",
  //     url: "chandigarh-university",
  //     image: "/assets/images/home/primium-university/Chandigarh .webp",
  //     alt_tag: "Chandigarh University Online",
  //     type: "Discover · Learn · Empower",
  //     nirf: "#19",
  //     specialisations: "16",
  //     naac: "A+",
  //     accred: "UGC · AICTE · NAAC A+",
  //     descHtml: `
  //   <p class="uni-desc">
  //     Chandigarh University is ranked #19 by NIRF with NAAC A+
  //     accreditation, trusted by <strong>over 3 lakh students</strong>
  //     nationwide. It offers 16 MBA specialisations.
  //   </p>
  // `,
  //     mode: "Online",
  //   },

  //   {
  //     id: 47,
  //     name: "Lovely Professional University",
  //     url: "lovely-professional-university",
  //     image: "/assets/images/home/primium-university/LPU-Online.png",
  //     alt_tag: "Lovely Professional University",
  //     type: "Same Degree, Now Online",
  //     nirf: "#49",
  //     specialisations: "12",
  //     naac: "A++",
  //     accred: "UGC · AICTE · NAAC A++",
  //     descHtml: `
  //   <p class="uni-desc">
  //     Lovely Professional University Online is ranked #49 by NIRF
  //     with NAAC A++ accreditation. Its UGC-entitled online MBA covers
  //     <strong>12 specialisations</strong>.
  //   </p>
  // `,
  //     mode: "Online",
  //   },

  //   {
  //     id: 40,
  //     name: "Symbiosis University",
  //     url: "symbiosis-university",
  //     image: "/assets/images/home/primium-university/Symbiosis.png",
  //     alt_tag: "Symbiosis University",
  //     type: "Centre for Distance Learning",
  //     nirf: "#24",
  //     specialisations: "24",
  //     naac: "A++",
  //     accred: "UGC · AICTE · NAAC A++",
  //     descHtml: `
  //   <p class="uni-desc">
  //     Symbiosis Centre for Distance Learning is ranked #24 by NIRF
  //     with <strong>NAAC A++ accreditation</strong>. SCDL offers
  //     24 specialisations across distance MBA, BBA, and postgraduate
  //     programs.
  //   </p>
  // `,
  //     mode: "Online",
  //   },
  // ];

  const staticUniversities = [
    {
      id: 39,
      accreditation: "UGC . AICTE . NAAC A++",
      university: "DY Patil",
      course: "MBA In Marketing Management",
      url: "dr-d-y-patil-university",
      image: "/assets/images/home/universities_images/dpu-200x400-1.jpg",
      fee: "1,89,400/-",
      duration: "2 Years",
      approval: "UGC / AICTE",
    },

    {
      id: 44,
      accreditation: "UGC . AICTE . NAAC A++",
      university: "NMIMS",
      course: "MBA In Human Resource Management",
      url: "nmims-university",
      image:
        "/assets/images/home/universities_images/college-images-and-logo-05-1024x512-1.jpg",
      fee: "1,68,000/-",
      duration: "2 Years",
      approval: "UGC / DEB",
    },

    {
      id: 44,
      accreditation: "UGC . AICTE . NAAC A++",
      university: "Online Manipal",
      course: "Online MBA In IT & Fintech",
      url: "Manipal",
      image:
        "/assets/images/home/universities_images/college-images-and-logo-03-2-1024x512-1.jpg",
      fee: "1,50,000/-",
      duration: "2 Years",
      approval: "UGC ",
    },

    {
      id: 45,
      accreditation: "UGC . AICTE . NAAC A+",
      university: "Sikkim Manipal University",
      course: "Online MBA In IT & Fintech",
      url: "Sikkim Manipal",
      image: "/assets/images/home/universities_images/SMU.png",
      fee: "98,000/-",
      duration: "2 Years",
      approval: "UGC / AICTE",
    },

    {
      id: 45,
      accreditation: "UGC . AICTE . NAAC A+",
      university: "Atlas SkillTech University",
      course: "Online MBA In IT & Fintech",
      url: "Atlas SkillTech University",
      image:
        "/assets/images/home/universities_images/34d4948b-ff6b-4140-aa7e-65034b35fb36.png",
      fee: "2,50,000/-",
      duration: "2 Years",
      approval: "UGC / AICTE",
    },

    {
      id: 34,
      accreditation: "UGC . AICTE . NAAC A+",
      university: "Amity University Online",
      course: "Online MBA In Digital Marketing ",
      url: "amity-university",
      image:
        "/assets/images/home/universities_images/college-images-and-logo-04-1-1024x512-1.jpg",
      fee: "2,25,000/-  ",
      duration: "2 Years",
      approval: "UGC / AICTE ",
    },

    {
      id: 37,
      accreditation: "UGC . AICTE . NAAC A+",
      university: "Chandigarh University Online",
      course: "Online MBA In IT & Fintech",
      url: "Chandigarh University",
      image: "/assets/images/home/universities_images/CU.png",
      fee: "2,00,000/-",
      duration: "2 Years",
      approval: "UGC / AICTE",
    },

    {
      id: 40,
      accreditation: "UGC . AICTE . NAAC A++",
      university: "Symbiosis University",
      course: "MBA In Marketing Management",
      url: "symbiosis-university",
      image:
        "/assets/images/home/universities_images/college-images-and-logo-02-1-1024x512-1.jpg",
      fee: "1,89,400/-",
      duration: "2 Years",
      approval: "UGC / AICTE",
    },

    {
      id: 47,
      accreditation: "UGC . AICTE . NAAC A++",
      university: "Lovely Professional University",
      url: "lovely-professional-university",
      course: "Online MBA In Data Science",
      image:
        "/assets/images/home/universities_images/college-images-and-logo-01-1-1024x512-1.jpg",
      fee: "2,60,000/-",
      duration: "2 Years",
      approval: "UGC",
    },
  ];

  const [modalshow, setmodalshow] = useState(false);
  const openModal = () => {
    setmodalshow(true);
    // setExpanded(false);
  };

  return (
    <section className="All_Universities common_div" id="programs">
      {" "}
      <div className="container">
        <Main_heading_holder
          heading="Find Below Top Colleges   "
          spanHeading="For Distance MBA"
          // subHeading="We are authorized academic partners with India's leading UGC-recognized universities, serving as their Online MBA Academic Advisors and guiding your journey every step of the way."
          headingType="h2"
        />

        <div className="new_section">
          {/* <div>
            <div>
              <h2 className="section-title">
                All <span className="inner_text">Universities</span>
              </h2>

              <p className="section-sub">
                Every institution is UGC-approved and NAAC-accredited — your
                degree is valid, respected, and recognised nationwide.
              </p>
            </div>
          </div> */}

          {/* <div className="row">
            {staticUniversities.map((uni) => (
              <div
                className="col-xxl-3 col-xl-4 col-md-6 mb-4 custom_col"
                key={uni.id}
              >
                <Link href={`/universities/${uni.url}/`}>
                  <div className="uni-card">
                    <div className="uni-card-top">
                      <div className="uni-logo-box">
                        <img
                          src={uni.image}
                          className="logo_img"
                          alt={uni.alt_tag}
                          width="190"
                          height="100"
                        />
                      </div>

                      <div className="uni-name-area">
                        <h3 className="uni-name">{uni.name}</h3>

                        <div className="uni-type">{uni.type}</div>
                      </div>
                    </div>

                    <div className="uni-body">
                      <div className="uni-metrics">
                        <div className="uni-metric">
                          <span className="uni-metric-val">{uni.nirf}</span>

                          <div className="uni-metric-key">NIRF Rank</div>
                        </div>

                        <div className="uni-metric">
                          <span className="uni-metric-val">
                            {uni.specialisations}
                          </span>

                          <div className="uni-metric-key">Specialisations</div>
                        </div>

                        <div className="uni-metric">
                          <span className="uni-metric-val">{uni.naac}</span>

                          <div className="uni-metric-key">NAAC</div>
                        </div>
                      </div>

                      <div className="uni-accred">{uni.accred}</div>

                      <div
                        dangerouslySetInnerHTML={{
                          __html: uni.descHtml,
                        }}
                      />
                    </div>

                    <div className="uni-footer">
                      <span className="uni-footer-link">Know More →</span>

                      <span className="uni-badge">{uni.mode}</span>
                    </div>
                  </div>
                </Link>
              </div>
            ))}
          </div> */}

          <div className="row">
            {staticUniversities.map((uni) => (
              <div className="col-xl-4 col-lg-4 col-md-6 mb-4" key={uni.id}>
                <div className="course_card">
                  <div className="course_image">
                    <img src={uni.image} alt={uni.course} />

                    {/* <div className="university_logo">
                      <img src={uni.logo} alt={uni.university} />
                    </div> */}
                  </div>

                  <div className="course_content">
                    <p className="accreditation">{uni.accreditation}</p>
                    <h3 className="course_title">
                      {uni.course}
                      <br />- {uni.university}
                    </h3>

                    <h4 className="course_fee">
                      {uni.fee}
                      <span> For {uni.duration}</span>
                    </h4>

                    {/* <p className="course_approval">
                      👍 Approved / Recognized By :<span> {uni.approval}</span>
                    </p> */}

                    <div className="course_btns">
                      <button className="enquire_btn" onClick={openModal}>
                        Enquire Now
                      </button>
                      <button onClick={openModal} className="download_btn">
                        Download Brochure
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      <InquiryFormModal
        show={modalshow}
        onHide={() => {
          setmodalshow(false);
          // setExpanded(false);
        }}
        setmodalshow={setmodalshow}
        modalshow={modalshow}
      />
    </section>
  );
};

export default All_Universities;
